import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AppUrls } from '../app-urls';
import { FcsOperation } from '../enums/fcs-operation.enum';
import { ParticipantOffersUrlBuilderService } from './participant-offers-url-builder.service';
import { ContextService } from './context.service';

@Injectable({
  providedIn: 'root'
})
  export class PermissionService {
  private permissionsSubject = new BehaviorSubject<Permissions | null>(null);
  public static isLoading = false;
  constructor(
    private http: HttpClient,
    private contextService: ContextService,
    private urlBuilder: ParticipantOffersUrlBuilderService
  ) {}

  public isOperationPermitted(operation: FcsOperation): boolean {
    return this.contextService.getPermittedOperations().indexOf(operation) != -1;
  }

  public getAllPermissions(): Observable<Permissions> {
    const permission = {
      permissions: [],
    };
    // TODO 15.04.25 Литвиненко: временно, заменить на getAbsoluteUrl после добавления апи пермиссий в participantoffers
    const url = this.urlBuilder.getTenderPlatformAbsoluteUrl(AppUrls.roles.permissions);
    return this.http.post<Permissions>(url, permission);
  }

  public fetchPermissions(): Observable<Permissions> {
    if (PermissionService.isLoading) {
      return this.getPermissionsFromCache();
    }
    PermissionService.isLoading = true;
    return this.getAllPermissions().pipe(
      tap((permissions) => {
        this.permissionsSubject.next(permissions);
        PermissionService.isLoading = false;
      }),
      catchError(() => {
        return of(null);
      })
    );
  }

  public getPermissionsFromCache(): Observable<Permissions | null> {
    return this.permissionsSubject.asObservable();
  }
}
